export const EXPIRED_PASSWORD_CODE = 419;